// src\hooks\useSymptomFlow.js
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  fetchSymptomsByLevel,
  fetchNextSymptomsOrDisease,
} from '../api/cropService';

/**
 * Hook to manage multi-level symptom Q&A flow and navigation
 * @param {number|string} cropId Crop ID
 */
export const useSymptomFlow = (cropId) => {
  const navigate = useNavigate();
  const [symptoms, setSymptoms] = useState([]);
  const [currentLevel, setCurrentLevel] = useState(1);
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(false);
  const handleBack = async () => {
    // Check if we're restoring state from advice page
    const savedFlowState = sessionStorage.getItem('symptomFlowState');
    if (savedFlowState) {
      try {
        const flowState = JSON.parse(savedFlowState);
        if (flowState.returnFromAdvice) {
          // Restore the symptom state directly
          setSymptoms(flowState.symptoms || []);
          setHistory(flowState.history || []);
          setCurrentLevel(flowState.currentLevel || 1);
          sessionStorage.removeItem('symptomFlowState');
          return;
        }
      } catch (err) {
        console.error('Error parsing flow state:', err);
      }
    }

    // Normal back navigation logic
    if (currentLevel === 1) {
      navigate("/");
      return;
    }

    console.log("handleBack called");
    setLoading(true);
    try {
      const newLevel = currentLevel - 1;
      const newHistory = history.slice(0, -1);
      
      if (newHistory.length === 0) {
        const initialSymptoms = await fetchSymptomsByLevel(cropId, 1);
        setSymptoms(initialSymptoms);
        setCurrentLevel(1);
      } else {
        const previousSymptoms = await fetchNextSymptomsOrDisease(cropId, newHistory.map(s => s.sid));
        setSymptoms(previousSymptoms.symptoms);
        setCurrentLevel(newLevel);
        setHistory(newHistory);
      }
    } catch (err) {
      console.error("Error going back to previous level:", err);
    } finally {
      setLoading(false);
    }
  };

  return {
    symptoms,
    setSymptoms,
    currentLevel,
    setCurrentLevel,
    history,
    setHistory,
    loading,
    setLoading,
    handleBack
  };
};
